import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Edit = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.24731 35.9401V43.7526H14.0598L37.1015 20.7109L29.289 12.8984L6.24731 35.9401ZM43.1432 14.6693C43.9557 13.8568 43.9557 12.5443 43.1432 11.7318L38.2682 6.85678C37.4557 6.04428 36.1431 6.04428 35.3306 6.85678L31.5182 10.6693L39.3307 18.4818L43.1432 14.6693Z"
        fill={color}
      />
    </svg>
  )
}
